export default __webpack_public_path__ + "static/media/upload.cffda988.svg";